import {useEffect, useState} from 'react'
import useContentAsset from './use-content-asset'
import useInternationalSite from './use-international-site'

const useChatbotLoader = (disableEcommerce, enableAlias, liveChatEnvironment) => {
    const [liveChatEnv, setLiveChatEnv] = useState('')

    const isInternationalSite = useInternationalSite()

    useEffect(() => {
        if (!isInternationalSite && liveChatEnvironment) {
            if (enableAlias) {
                setLiveChatEnv('livechatscript_' + liveChatEnvironment + '_alias')
            } else {
                setLiveChatEnv('livechatscript_' + liveChatEnvironment)
            }
        }
    }, [disableEcommerce, enableAlias, liveChatEnvironment])

    const {data: chatbotScript} = useContentAsset(liveChatEnv)

    useEffect(() => {
        if (!chatbotScript?.body) return

        const container = document.createElement('div')
        container.innerHTML = chatbotScript?.body

        const scripts = Array.from(container.querySelectorAll('script'))
        const addedScripts = []

        const existingScriptsSrc = new Set(
            Array.from(document.querySelectorAll('script[src]')).map((s) => s.src)
        )

        const existingInlineScripts = new Set(
            Array.from(document.querySelectorAll('script:not([src])')).map((s) =>
                s.textContent.trim()
            )
        )

        scripts.forEach((script) => {
            const isExternal = !!script.src
            if (
                (isExternal && existingScriptsSrc.has(script.src)) ||
                (!isExternal && existingInlineScripts.has(script.textContent.trim()))
            ) {
                return
            }

            const newScript = document.createElement('script')

            for (const attr of script.attributes) {
                newScript.setAttribute(attr.name, attr.value)
            }

            if (script.textContent) {
                newScript.textContent = script.textContent
            }

            document.body.appendChild(newScript)
            addedScripts.push(newScript)
        })

        // MutationObserver to watch for Messenger link ejection
        const observer = new MutationObserver(() => {
            const links = document.querySelectorAll('.cta-link-customurl')
            if (links.length > 0) {
                links.forEach((link) => {
                    link.setAttribute('target', '_blank')
                    link.setAttribute('rel', 'noopener noreferrer')
                })
                observer.disconnect() // stop observing once applied
            }
        })

        observer.observe(document.body, {childList: true, subtree: true})

        // Cleanup
        return () => {
            observer.disconnect()
        }
    }, [chatbotScript?.body])
}

export default useChatbotLoader
